import {
  LOAD_SHOPIFY_ORDERS,
  RESET_SHOPIFY_STATE,
  SET_SHOPIFY_ORDERS,
  SET_SHOPIFY_FEES,
  LOAD_SHOPIFY_FEES
} from '@/state/mutationTypes'
import getShopifyStoreDefaultState from '@/state/shopifyStore/shopifyStoreDefaultState'

export default {
  [LOAD_SHOPIFY_ORDERS](state, payload) {
    state.loadShopifyOrders = payload
  },
  [LOAD_SHOPIFY_FEES](state, payload) {
    state.loadShopifyFees = payload
  },
  [SET_SHOPIFY_ORDERS](state, payload) {
    state.orders = payload
  },
  [SET_SHOPIFY_FEES](state, payload) {
    state.fees = payload
  },
  [RESET_SHOPIFY_STATE](state) {
    Object.assign(state, getShopifyStoreDefaultState())
  }
}
